import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const VideoformatServiceConfig = {
  name: "Videoformat",
  annotations: []
} as ServiceConfig;